import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameSectionStore } from "../stores/gamesSection";
import { gameStore } from "../stores/games";
import { blackListWithdrawalsStore } from "../stores/blackListWithdrawals";
import {
	blackListWithdrawalsAddModalStore,
	blackListWithdrawalsEditModalStore,
} from "../stores/blackListWithdrawalsEditModal";
/* ------- */

class BlackListWithdrawalsEditModal extends React.Component {
	componentDidUpdate(prevProps) {
		if (!prevProps.blackListWithdrawalsEditModal.show && this.props.blackListWithdrawalsEditModal.show) {
			this.resetFormFields();
		}
	}

	resetFormFields = () => {
		this.props.setBlackListWithdrawalsEditModal({
			...this.props.blackListWithdrawalsEditModal,
			wallet: '',
			loaded: true
		});
	};


	addBlackListWithdrawal() {
		const data = {
			wallet: this.props.blackListWithdrawalsEditModal.wallet,
			description: this.props.blackListWithdrawalsEditModal.description,
			id: this.props.blackListWithdrawalsEditModal.id,
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "blackListWithdrawals",
			method: "edit"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Edit black list was success");
			this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, show: false});
			this.props.Interface.loadBlackListWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setBlackListWithdrawal({ ...this.props.blackListWithdrawal, loaded: true, error });
		})
	}


	render() {
		return (
			<>
				<Modal
					visible={this.props.blackListWithdrawalsEditModal.show}
					onDismiss={() => {
						this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, show: false });
					}}
					header="Edit wallet to black list"
					children={
						<>
							<SpaceBetween direction="vertical" size="m">
								<Input
									autoFocus="true"
									name="Name"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Wallet"
									value={this.props.blackListWithdrawalsEditModal.wallet}
									onChange={(input) => {
										this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, wallet: input.detail.value });
									}}
								/>
								<Input
									autoFocus="true"
									name="Description"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Description"
									value={this.props.blackListWithdrawalsEditModal.description}
									onChange={(input) => {
										this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, description: input.detail.value });
									}}
								/>
							</SpaceBetween>
						</>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													onClick={() => {
														this.props.setBlackListWithdrawalsEditModal({ ...this.props.blackListWithdrawalsEditModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													disabled={this.props.blackListWithdrawalsEditModal.wallet === ""}
													variant="primary"
													onClick={() => {
														this.addBlackListWithdrawal();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const blackListWithdrawalsEditModal = useRecoilValue(blackListWithdrawalsEditModalStore);
		const setBlackListWithdrawalsEditModal = useSetRecoilState(blackListWithdrawalsEditModalStore);
		const blackListWithdrawal = useRecoilValue(blackListWithdrawalsStore);
		const setBlackListWithdrawal = useSetRecoilState(blackListWithdrawalsStore);
		const config = useRecoilValue(configStore);
		return <Component {...props}  blackListWithdrawalsEditModal={blackListWithdrawalsEditModal} setBlackListWithdrawalsEditModal={setBlackListWithdrawalsEditModal} blackListWithdrawal={blackListWithdrawal} setBlackListWithdrawal={setBlackListWithdrawal} config={config} />;
	};
}

export default withRecoil(BlackListWithdrawalsEditModal);
